var React = require('react');

function MehBlank (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM168,240a32,32,0,1,1,32-32A32,32,0,0,1,168,240Zm160,0a32,32,0,1,1,32-32A32,32,0,0,1,328,240Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M168,176a32,32,0,1,0,32,32A32,32,0,0,0,168,176Zm160,0a32,32,0,1,0,32,32A32,32,0,0,0,328,176Z","className":"fa-primary","key":2})]);
}

MehBlank.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = MehBlank;

MehBlank.default = MehBlank;
